/**
 * Mapping for fields of dataset-related to their display names.
 */
export const dataset_all_mapping = {
  "organizations": "專案",
  "authors": "產製者",
  "data_types": "資料類型",
  "tags": "標籤",
  "keywords": "Wikidata 關鍵字",
  "resources_formats": "資源格式",
  "license_ids": "授權方式",
  "groups":"主題",
};

/**
 * Mapping for fields of daily fetch data to their display names.
 */
export const daily_fetch_mapping = {
  "organization": "專案",
  "data_type": "資料類型",
  "tags": "標籤",
  "keywords": "Wikidata 關鍵字",
  "resources": "資料集資源",
  "license_id": "授權方式",
  "groups": "主題",
};

/**
 * Mapping for dataset statistics fields to their display names.(Histogram & Box plot)
 */
export const dataset_stats_mapping = {
  "data_type": "資料類型",
  "tags": "標籤",
  "keywords": "Wikidata 關鍵字",
  "resources": "資料集資源",
  "groups": "主題",
};

export const top_datasets_mapping = {
  "organizations":"有最多資料集的專案",
  "authors":"有最多資料集的產製者",
  "data_types":"最常見的資料類型",
  "tags":"最常見的標籤",
  "keywords":"最常見的 Wikidata 關鍵字",
  "resources_formats": "最常見的資源格式",
  "license_ids":"最多資料集的授權方式",
  "groups":"最多資料集的主題",
}

/**
 * Mapping for column fields to their display names.(Area chart)
 */
export const num_overtime_mapping = {
  "num_datasets": "資料集總數",
  "num_organizations": "專案總數",
  "num_tags": "標籤總數",
  "num_keywords": "Wikidata 關鍵字總數",
  "num_authors": "產製者總數",
  "num_resources": "資源總數",
  "total_views": "瀏覽次數總數"
}

/**
 * Mapping for statistical operations to their display names.
 */
export const operation = {
  "mean": "中位數",
  "median": "中位數",
  "mode": "眾數"
};

/**
 * Mapping for dataset-level metadata fields to their display names.
 */
export const dataset_metadata_mapping = {
  "title": "標題", 
  "name": "網址", 
  "notes": "摘要", 
  "data_type": "資料類型",
  "keywords": "Wikidata 關鍵字", 
  "tags": "標籤", 
  "language": "語言",
  "remarks": "備註",
  "temp_res": "時間解析度", 
  "start_time": "起始時間", 
  "end_time": "結束時間", 
  "spatial": "空間範圍",
  "x_min": "空間範圍.X.min", 
  "x_max": "空間範圍.X.max", 
  "y_min": "空間範圍.Y.min", 
  "y_max": "空間範圍.Y.max",
  "spatial_res": "空間解析度", 
  "license_id": "授權", 
  "author": "產製者", 
  "created_time": "資料產製時間",
  "process_step": "資料處理歷程", 
  "owner_org": "專案", 
  "contact_person": "聯絡人", 
  "contact_email": "聯絡人的電子郵件"
}

/**
 * Mapping for resource-level metadata fields to their display names.
 */
export const res_metadata_mapping = {
  "url": "網址", 
  "name": "名稱", 
  "description": "摘要", 
  "encoding": "字元編碼",
  "resource_crs": "座標參考系統", 
  "format": "格式"
}

export const table_column_mapping = {
  "display_name": "顯示名稱",
  "name": "名稱",
  "count": "總數量",
  "en_label": "英文標籤",
  "zh_tw_label": "中文標籤",
  "presence": "出現次數",
}

export const tracking_table_column_mapping = {
    title: '資料集名稱',
    name: '名稱',
    view_percentage: '專案瀏覽次數比例',
    tracking: '瀏覽次數'
};
